(ns storrito.date.datetime-local
  "Helpers for HTML datetime-local input values.")

(def minute-ms
  (* 1000 60))

(defn date-ms
  [date-str]
  (when (seq (str date-str))
    (let [ms (.getTime (js/Date. date-str))]
      (when-not (js/isNaN ms)
        ms))))

(defn format-date
  [date]
  (let [pad (fn [n]
              (if (< n 10)
                (str "0" n)
                (str n)))]
    (str (.getFullYear date) "-"
         (pad (inc (.getMonth date))) "-"
         (pad (.getDate date)) "T"
         (pad (.getHours date)) ":"
         (pad (.getMinutes date)))))

(defn current-datetime-local
  "Returns the current date/time formatted for a datetime-local input."
  []
  (format-date (js/Date.)))

(defn current-minute-ms
  []
  (* minute-ms
     (.floor js/Math (/ (.getTime (js/Date.))
                        minute-ms))))

(defn current-minute-or-future?
  [ms]
  (and ms
       (>= ms
           (current-minute-ms))))

(defn date-in-future?
  [date-str]
  (when-let [ms (date-ms date-str)]
    (> ms (.getTime (js/Date.)))))

(defn next-10-minute-datetime-local
  []
  (let [now (js/Date.)
        minutes (.getMinutes now)
        rounded-minutes (+ minutes (- 10 (mod minutes 10)))
        rounded (js/Date. (.getFullYear now)
                          (.getMonth now)
                          (.getDate now)
                          (.getHours now)
                          rounded-minutes)]
    (format-date rounded)))
